import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const selectCountry = country => actionResponseFactory(types.SELECT_COUNTRY, { country });
export const removeCountry = country => actionResponseFactory(types.REMOVE_COUNTRY, { country });
export const removeAllCountries = () => actionResponseFactory(types.REMOVE_ALL_COUNTRIES);
export const addSelectedCountries = countries =>
  actionResponseFactory(types.ADD_SELECTED_COUNTRIES, { countries });

/**
 * Get list of countries
 * @param {number} [limit=300] Number of results. API defaults to 99, but we never used it paged. Currently there are 258 countries. Setting the limit to 300 gives us a bit of room in case the number changes.
 * @returns {Function} Action creator for GET_COUNTRIES_REQUEST
 */

export const getCountriesRequest = (limit = 300) =>
  actionRequestFactory(types.GET_COUNTRIES_REQUEST, limit);
export const getCountriesSuccess = countries =>
  actionResponseFactory(types.GET_COUNTRIES_SUCCESS, { countries });
export const getCountriesFailure = error =>
  actionResponseFactory(types.GET_COUNTRIES_FAILURE, { error });
